export default __webpack_public_path__ + "locales/sq-AL/ArchiveDialog.json?hash=66ed1c392a7a1ff29f9fac584c193527";